
import { ChargingStation } from '@/types/task';
import Map from '@/components/Map';
import StationList from '@/components/StationList';
import { Button } from '@/components/ui/button';

interface StationContentProps {
  showMap: boolean;
  filteredStations: ChargingStation[];
  searchQuery: string;
  isLoading: boolean;
  onStationSelect: (station: ChargingStation) => void;
  onClearFilters: () => void;
}

const StationContent = ({
  showMap,
  filteredStations,
  searchQuery,
  isLoading,
  onStationSelect,
  onClearFilters,
}: StationContentProps) => {
  return (
    <>
      {showMap ? (
        <Map 
          stations={filteredStations} 
          onStationSelect={onStationSelect}
          className="mb-6 rounded-xl shadow-lg border border-gray-100"
        />
      ) : (
        <div className="transition-all duration-300 animate-fade-in">
          <StationList 
            stations={filteredStations}
            searchQuery={searchQuery}
            isLoading={isLoading}
          />
        </div>
      )}
      
      {filteredStations.length === 0 && !isLoading && (
        <div className="text-center py-10 bg-gray-50 rounded-xl shadow-sm border border-gray-100">
          <h3 className="text-xl font-medium">No charging stations found</h3>
          <p className="text-muted-foreground mt-2">
            Try adjusting your search or filters
          </p>
          <Button
            variant="outline" 
            className="mt-4"
            onClick={onClearFilters}
          >
            Clear all filters
          </Button>
        </div>
      )}
    </>
  );
};

export default StationContent;
